import { Component, OnInit, ViewChild } from '@angular/core';
import { NzModalRef, NzMessageService, NzFormatEmitEvent, NzTreeNode } from 'ng-zorro-antd';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Observable, Observer} from 'rxjs';
import {RoleService, UserService} from "@ecip/service";

@Component({
  selector: 'app-user-local-role',
  templateUrl: './user.role.component.html'
})
export class UserLocalRoleComponent implements OnInit {
  record: any = {};
  i: any;
  form: FormGroup;
  roleList: any = [];
  loading: boolean = false;

  constructor(
    private modal: NzModalRef,
    public msgSrv: NzMessageService,
    public roleService: RoleService,
    public userService: UserService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      roleIds: [null, []]
    });
    this.loading = true;
    Observable.forkJoin([this.roleService.getList(),
      this.userService.findRoleIds(this.record.id)]).subscribe(([roleList, roleIds]) => {
      this.roleList = roleList;
      this.form.get('roleIds').setValue(roleIds);
      this.loading = false;
    });
  }

  submit() {
    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (this.form.invalid) return;
    //ä¿®æ¹
    this.userService.saveRole(this.record.id, this.form.get('roleIds').value).subscribe(res => {
      this.msgSrv.success('ä¿å­æå');
      this.modal.close(true);
    });
  }

  close() {
    this.modal.destroy();
  }
}
